export default "__VITE_ASSET__74559f1b__"